import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useUiStore = defineStore('ui', () => {
  // デフォルトは閉じている状態 (true)
  const isSidebarCollapsed = ref(
    localStorage.getItem('rabiitrip_sidebar_collapsed') !== null
      ? localStorage.getItem('rabiitrip_sidebar_collapsed') === 'true'
      : true
  );

  const toggleSidebar = () => {
    isSidebarCollapsed.value = !isSidebarCollapsed.value;
    localStorage.setItem(
      'rabiitrip_sidebar_collapsed',
      String(isSidebarCollapsed.value)
    );
  };

  const closeSidebar = () => {
    isSidebarCollapsed.value = true;
    localStorage.setItem('rabiitrip_sidebar_collapsed', 'true');
  };

  const openSidebar = () => {
    isSidebarCollapsed.value = false;
    localStorage.setItem('rabiitrip_sidebar_collapsed', 'false');
  };

  const setSidebarCollapsed = (value) => {
    isSidebarCollapsed.value = value;
    localStorage.setItem(
      'rabiitrip_sidebar_collapsed',
      String(value)
    );
  };

  return {
    isSidebarCollapsed,
    toggleSidebar,
    closeSidebar,
    openSidebar,
    setSidebarCollapsed,
  };
});
